import Swiper from 'swiper';
import { initSwiperOnMount } from '../../gutenberg-swiper';

class BlockListingAides {
  constructor() {
    this._init();
  }

  _init() {
    initSwiperOnMount('.listing-aides__swiper', (element) => {
      new Swiper(element, {
        direction: 'horizontal',
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        preventInteractionOnTransition: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 40
          }
        }
      });
    });
  }
}

export const blockSliderMedias = new BlockListingAides();
